export const MEMBERSHIP_DENIED_CODES = new Set([
  'membership_required',
  'not_linked',
  'premium_required',
]);

export function isMembershipAccessDenied(status, payload = {}) {
  if (Number(status) !== 403) return false;
  if (MEMBERSHIP_DENIED_CODES.has(payload?.code)) return true;
  const msg = String(payload?.message || '').toLowerCase();
  return msg.includes('gói hội viên')
    || msg.includes('membership')
    || msg.includes('nâng cấp')
    || msg.includes('liên kết');
}

export function isMembershipDeniedError(err) {
  if (!err) return false;
  if (err.isMembershipDenied) return true;
  if (MEMBERSHIP_DENIED_CODES.has(err?.code)) return true;
  const msg = String(err?.message || '').toLowerCase();
  return msg.includes('gói hội viên')
    || msg.includes('yêu cầu gói')
    || msg.includes('nâng cấp tại trang membership');
}

export function markMembershipDeniedError(err, payload = {}) {
  if (!err) return err;
  err.isMembershipDenied = isMembershipAccessDenied(403, payload)
    || isMembershipDeniedError(err);
  if (payload?.code) err.code = payload.code;
  return err;
}
